import { token } from './sesion';

const API_URL = ((import.meta.env.VITE_API_URL as string | undefined) ?? '').replace(/\/$/, '');

export interface Direccion {
  street: string;
  colonia: string;
  cp: string;
  city: string;
  state: string;
  references: string;
}

export interface Perrito {
  id: string;
  name: string;
  breed: string;
  backCm: number;
  chestCm: number | null;
}

export interface Perfil {
  id: string;
  email: string;
  name: string;
  phone: string;
  address: Direccion | null;
  dogs: Perrito[];
  marketingOptIn: boolean;
}

export interface PedidoCliente {
  id: string;
  createdAt: string;
  status: string;
  totalCents: number;
  lines: { productId: string; name: string; size: string; qty: number }[];
  tracking?: string;
}

async function llamar<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: { authorization: `Bearer ${await token()}`, ...(body === undefined ? {} : { 'content-type': 'application/json' }) },
    body: body === undefined ? undefined : JSON.stringify(body),
    cache: 'no-store',
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) throw new Error(data.error ?? `Error ${res.status}`);
  return data as T;
}

export const cuentaApi = {
  perfil: () => llamar<Perfil>('GET', '/me'),
  guardar: (p: Perfil) =>
    llamar<Perfil>('PUT', '/me', { name: p.name, phone: p.phone, address: p.address, dogs: p.dogs, marketingOptIn: p.marketingOptIn }),
  borrar: () => llamar<void>('DELETE', '/me'),
  pedidos: async () => (await llamar<{ orders: PedidoCliente[] }>('GET', '/me/orders')).orders,
};
